export default "__VITE_ASSET__Dx1d_MB2__"